import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AiChatService } from '../../../core/services/ai-chat.service'
import { CrispService } from '../../../core/services/crisp.service'
import { OneIconComponent } from '../one-icon/one-icon.component'
import { OneTooltipDirective } from '../../directives/one-tooltip.directive'

@Component({
  selector: 'one-ai-chat-button',
  standalone: true,
  imports: [
    CommonModule,
    OneIconComponent,
    OneTooltipDirective,
  ],
  templateUrl: './ai-chat-button.component.html',
  styleUrls: ['./ai-chat-button.component.scss']
})
export class AiChatButtonComponent {
  constructor(
    private aiChatService: AiChatService,
    private crispService: CrispService,
  ) {}

  toggleChat() {
    this.aiChatService.toggleChat()
  }

  openSupportChat(event: MouseEvent) {
    event.stopPropagation()
    const crisp = this.crispService.getCrisp()
    if (crisp && typeof crisp.push === 'function') {
      crisp.push(["do", "chat:show"]);
      crisp.push(["do", "chat:open"]);
    }
  }
} 
